// extracted by mini-css-extract-plugin
export default {"fields":"itemType_fields__rTCbg","checkbox":"itemType_checkbox__GmhdB"};